import Swiper from 'swiper';

const FeaturedPostSlider = () => {
    const init = () => {
        const carousels = document.querySelectorAll('.featured-post__carousel.swiper');

        if (!carousels.length) {
            return;
        }

        carousels.forEach((carousel) => {
            const section = carousel.closest('.featured-post');
            const prevButton = section?.querySelector('.swiper-pagination__button-prev');
            const nextButton = section?.querySelector('.swiper-pagination__button-next');

            if (!prevButton || !nextButton) {
                return;
            }

            const swiper = new Swiper(carousel, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: false,
                speed: 600,
                autoHeight: true,
            });

            const updateButtonStates = () => {
                prevButton.disabled = swiper.isBeginning;
                nextButton.disabled = swiper.isEnd;

                prevButton.classList.toggle('swiper-button-disabled', swiper.isBeginning);
                nextButton.classList.toggle('swiper-button-disabled', swiper.isEnd);
            };

            prevButton.addEventListener('click', () => {
                swiper.slidePrev();
            });

            nextButton.addEventListener('click', () => {
                swiper.slideNext();
            });

            updateButtonStates();
            swiper.on('slideChange', updateButtonStates);
        });
    };

    return {
        init
    };
};

export default FeaturedPostSlider;
